export const responsiveLimit = 500;

export const BrandColors = {
    Loading: '#FF0000',
};
